import { http } from '@uhg-abyss/web/tools/http';
import { event as eapmEvent } from '@uhg-abyss/web/tools/event';
import { getLandingStatusError } from './errors';

export const getOnFetchingUserRequest = async (action) => {
  const response = await http({
    method: 'GET',
    url: `${action.url}/userinfo`,
    handleError: getLandingStatusError,
    cache: false,
  });
  const { duration, status, data } = response;
  const successData = {
    endpoint: `${action.url}/userinfo`,
    duration,
    status,
  };

  eapmEvent('EAPM_TRANSACTION_SUCCESS', successData);

  return data;
};
